import { render, staticRenderFns } from "./people-dept.vue?vue&type=template&id=43973e0c&scoped=true&"
import script from "./people-dept.vue?vue&type=script&lang=js&"
export * from "./people-dept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43973e0c",
  null
  
)

export default component.exports